import './title.css'

const Title = ({title, icon}) => {

      return (
            <div className="title_header">
                  <div className="title_icon">
                        {icon}
                  </div>
                  <h3>{title}</h3>
            </div>
      )
}

export default Title
